import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormTextField from "../../components/formFields/FormTextField";
import {
  emailValidator,
  MobileNoIntValidator,
  requiredArrayValidator,
  requiredValidator,
} from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import RippleButton from "../../components/common/RippleButton";
import ShadowCard from "../../components/common/ShadowCard";
import {
  createFlightInquiry,
  createPackageInquiry,
  getFlightInquiryByID,
  getInquiryByID,
  getPackageInquiryByID,
  updateFlightInquiry,
  updatePackageInquiry,
} from "./services/inquiry.services";
import { clearInquiryDetails } from "./inquirySlice";
import ButtonForAll from "../../components/common/ButtonForAll";
import { getAllActiveLeadSource } from "../leadsource/services/leadsource.service";
import { ILeadSource } from "../leadsource/leadsourceModel";
import FormDatePicker from "../../components/formFields/FormDateField";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import {
  HOTELPREFERENCE,
  INQUIRYQUERIES,
  NAMEPREFIX,
  QUERYTYPES,
  TRIPTYPE,
} from "../../_contstants/common";
import moment from "moment";
import { getLeadByID } from "../lead/services/lead.services";
import FormRadioGroup from "../../components/formFields/FormRadioGroup";
import FormMultiSelectionFiled from "../../components/formFields/FormMultiSelectionFiled";
import { getAllActiveCities } from "../city/services/city.services";
import { ICity } from "../city/cityModel";
import FormCheckboxGroup from "../../components/formFields/FormCheckboxGroup";
import { getAllActiveFoodOptions } from "../foodoption/services/foodOption.services";
import { IFoodOption } from "../foodoption/foodOptionModel";
import { IAirlineClass } from "../airlineclass/airlineclassModel";
import { IAirline } from "../airline/airlineModel";
import { getAllActiveAirlines } from "../airline/services/airline.services";
import { getAllActiveAirlineClass } from "../airlineclass/services/airlineclass.services";
import CountryCodeField from "../../components/formFields/CountryCodeField";
import { clearLeadDetails } from "../lead/leadSlice";
import { insertContactFromOtherPlace } from "../contact/services/contact.services";

const PAXCOUNT = [
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8", value: "8" },
  { label: "9", value: "9" },
];

const CreateInquiry: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const InquiryID = location.state?.InquiryID;
  const RequirementType = location.state?.RequirementType;
  const LeadID = location.state?.LeadID;
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();

  const loading = useAppSelector((state) => state.inquiry.loading);
  const InquiryDetails = useAppSelector(
    (state) => state.inquiry.InquiryDetails
  );
  const InquiryPackageDetails = useAppSelector(
    (state) => state.inquiry.InquiryPackageDetails
  );
  const InquiryFlightDetails = useAppSelector(
    (state) => state.inquiry.InquiryFlightDetails
  );
  const LeadDetails = useAppSelector((state) => state.lead.LeadDetails);
  const leadLoading = useAppSelector((state) => state.lead.formLoading);
  const LeadSourceList = useAppSelector(
    (state) => state.leadsource.LeadSourceList
  );
  // const LeadStageList = useAppSelector(
  //   (state) => state.leadStage.LeadStageList
  // );
  const CityList = useAppSelector((state) => state.city.CityList);
  const AirlineList = useAppSelector((state) => state.airline.AirlineList);
  const AirlineClassList = useAppSelector(
    (state) => state.airlineclass.AirlineClassList
  );
  const FoodOptionList = useAppSelector(
    (state) => state.foodOption.FoodOptionList
  );

  const [formKey, setFormKey] = useState(1);
  const [initialValues, setInitialValues] = useState<any>({});

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [initialValues]);

  useEffect(() => {
    if (RequirementType === "FLIGHT") {
      setInitialValues(InquiryFlightDetails);
    } else if (RequirementType === "PACKAGE") {
      setInitialValues(InquiryPackageDetails);
    } else {
      setInitialValues({
        ...InquiryDetails,
        ExpClosureDate: InquiryDetails?.ExpClosureDate
          ? moment(InquiryDetails?.ExpClosureDate, "YYYY-MM-DD")?.toDate()
          : "",
        TravelDate: InquiryDetails?.TravelDate
          ? moment(InquiryDetails?.TravelDate, "YYYY-MM-DD")?.toDate()
          : "",
        DepartureDate: InquiryDetails?.DepartureDate
          ? moment(InquiryDetails?.DepartureDate, "YYYY-MM-DD")?.toDate()
          : "",
        ReturnDate: InquiryDetails?.ReturnDate
          ? moment(InquiryDetails?.ReturnDate, "YYYY-MM-DD")?.toDate()
          : "",
        Adult: InquiryDetails?.Adult ? `${InquiryDetails?.Adult}` : null,
        Child:
          InquiryDetails?.Child !== 0 ? `${InquiryDetails?.Child}` : "zero",
        Infant:
          InquiryDetails?.Infant !== 0 ? `${InquiryDetails?.Infant}` : "zero",
        PreferredAirlineID: InquiryDetails?.PreferredAirlineID
          ? InquiryDetails?.PreferredAirlineID?.split(", ")?.map(
              (flight: any) => +flight
            )
          : "",
        DestinationID: InquiryDetails?.DestinationID
          ? InquiryDetails?.DestinationID?.split(",")?.map(
              (destination: any) => +destination
            )
          : "",
        HotelPreference: InquiryDetails?.HotelPreference
          ? InquiryDetails?.HotelPreference?.split(",")?.map((pref: any) =>
              pref?.trim()
            )
          : "",
      });
    }
  }, [InquiryPackageDetails, InquiryFlightDetails, InquiryDetails]);

  useEffect(() => {
    if (LeadDetails?.ID) {
      setInitialValues({
        ...InquiryDetails,
        FirstName: LeadDetails?.FirstName,
        LastName: LeadDetails?.LastName,
        MobileNo: LeadDetails?.MobileNo,
        EmailID: LeadDetails?.EmailID,
        InquirySourceID: LeadDetails?.LeadSourceID,
        ContactID: LeadDetails?.ContactID,
        LeadID: LeadDetails?.ID,
      });
    }
    return () => {
      dispatch(clearLeadDetails());
    };
  }, [LeadDetails]);

  useEffect(() => {
    if (InquiryID) {
      if (RequirementType === "PACKAGE") {
        dispatch(getPackageInquiryByID(InquiryID));
      } else if (RequirementType === "FLIGHT") {
        dispatch(getFlightInquiryByID(InquiryID));
      } else {
        dispatch(getInquiryByID(InquiryID));
      }
    } else if (LeadID) {
      dispatch(getLeadByID(LeadID));
    }
  }, [InquiryID]);

  useEffect(() => {
    dispatch(getAllActiveCities());
    dispatch(getAllActiveAirlines());
    dispatch(getAllActiveAirlineClass());
    dispatch(getAllActiveLeadSource());
    dispatch(getAllActiveFoodOptions());
    return () => {
      dispatch(clearInquiryDetails());
    };
  }, []);

  const handleSubmit = async (values: any) => {
    let contactID = values?.ContactID ? +values?.ContactID : null;
    const insertContactPayload = {
      Initial: values?.Initial ? values?.Initial : "",
      FirstName: values?.FirstName ? values?.FirstName : "",
      LastName: values?.LastName ? values?.LastName : "",
      MobileNo: values?.MobileNo ? values?.MobileNo : "",
      CountryCode: values?.CountryCode ? values?.CountryCode : "",
      EmailID: values?.EmailID ? values?.EmailID : "",
      LeadSourceID: values?.LeadSourceID ? +values?.LeadSourceID : null,
    };

    if (!LeadID && !InquiryID) {
      const response = await dispatch(
        insertContactFromOtherPlace(insertContactPayload)
      );

      if (
        response.meta.requestStatus === "fulfilled" &&
        response.payload?.Data?.ID
      ) {
        contactID = +response.payload.Data.ID || null;
      } else {
        return;
      }
    }

    if (values?.RequirementType === "PACKAGE") {
      if (InquiryID) {
        const editPayload = {
          ID: InquiryID ? +InquiryID : null,
          RequirementType: values?.RequirementType
            ? values?.RequirementType
            : "",
          FirstName: values?.FirstName ? values?.FirstName : "",
          LastName: values?.LastName ? values?.LastName : "",
          MobileNo: values?.MobileNo ? `${values?.MobileNo}` : "",
          EmailID: values?.EmailID ? values?.EmailID : "",
          DestinationID: values?.DestinationID
            ? values?.DestinationID?.join(", ")
            : "",
          GoingfromID: values?.GoingfromID ? +values?.GoingfromID : null,
          FoodPreferenceID: values?.FoodPreferenceID
            ? +values?.FoodPreferenceID
            : null,
          TravelDate: values?.TravelDate
            ? moment(values?.TravelDate)?.format("YYYY-MM-DD")
            : null,
          NoOfNights: values?.NoOfNights ? +values?.NoOfNights : null,
          NoOfPax: values?.NoOfPax ? +values?.NoOfPax : null,
          Budget: values?.Budget ? +values?.Budget : null,
          InquirySourceID: values?.InquirySourceID
            ? +values?.InquirySourceID
            : null,
          ExpClosureDate: values?.ExpClosureDate
            ? moment(values?.ExpClosureDate)?.format("YYYY-MM-DD")
            : null,
          ExpClosureAmount: values?.ExpClosureAmount
            ? +values?.ExpClosureAmount
            : null,
          HotelPreference: values?.HotelPreference
            ? values?.HotelPreference?.join(", ")
            : "",
          QueryType: values?.QueryType ? values?.QueryType : "",
          Remarks: values?.Remarks ? values?.Remarks : "",
        };
        try {
          const response = await dispatch(updatePackageInquiry(editPayload));
          if (response?.meta?.requestStatus === "fulfilled") {
            dispatch(clearInquiryDetails());
            navigate(-1);
          }
        } catch (error) {
          console.error("Error in handleSubmit:", error);
          throw error;
        }
      } else {
        const insertPayload = {
          ContactID: contactID,
          LeadID: values?.LeadID ? +values?.LeadID : null,
          RequirementType: values?.RequirementType
            ? values?.RequirementType
            : "",
          FirstName: values?.FirstName ? values?.FirstName : "",
          LastName: values?.LastName ? values?.LastName : "",
          MobileNo: values?.MobileNo ? `${values?.MobileNo}` : "",
          EmailID: values?.EmailID ? values?.EmailID : "",
          DestinationID: values?.DestinationID
            ? values?.DestinationID?.join(", ")
            : "",
          GoingfromID: values?.GoingfromID ? +values?.GoingfromID : null,
          FoodPreferenceID: values?.FoodPreferenceID
            ? +values?.FoodPreferenceID
            : null,
          TravelDate: values?.TravelDate
            ? moment(values?.TravelDate)?.format("YYYY-MM-DD")
            : null,
          NoOfNights: values?.NoOfNights ? +values?.NoOfNights : null,
          NoOfPax: values?.NoOfPax ? +values?.NoOfPax : null,
          Budget: values?.Budget ? +values?.Budget : null,
          InquirySourceID: values?.InquirySourceID
            ? +values?.InquirySourceID
            : null,
          ExpClosureDate: values?.ExpClosureDate
            ? moment(values?.ExpClosureDate)?.format("YYYY-MM-DD")
            : null,
          ExpClosureAmount: values?.ExpClosureAmount
            ? +values?.ExpClosureAmount
            : null,
          HotelPreference: values?.HotelPreference
            ? values?.HotelPreference?.join(", ")
            : "",
          QueryType: values?.QueryType ? values?.QueryType : "",
          Remarks: values?.Remarks ? values?.Remarks : "",
        };
        try {
          const response = await dispatch(createPackageInquiry(insertPayload));
          if (response?.meta?.requestStatus === "fulfilled") {
            dispatch(clearInquiryDetails());
            navigate(-1);
          }
        } catch (error) {
          console.error("Error in handleSubmit:", error);
          throw error;
        }
      }
    } else if (values?.RequirementType === "FLIGHT") {
      if (InquiryID) {
        const editPayload = {
          ID: InquiryID ? +InquiryID : null,
          RequirementType: values?.RequirementType
            ? values?.RequirementType
            : "",
          FirstName: values?.FirstName ? values?.FirstName : "",
          LastName: values?.LastName ? values?.LastName : "",
          MobileNo: values?.MobileNo ? `${values?.MobileNo}` : "",
          EmailID: values?.EmailID ? values?.EmailID : "",
          TripType: values?.TripType ? values?.TripType : "",
          FromPlaceID: values?.FromPlaceID ? +values?.FromPlaceID : null,
          ToPlaceID: values?.ToPlaceID ? +values?.ToPlaceID : null,
          DepartureDate: values?.DepartureDate
            ? moment(values?.DepartureDate)?.format("YYYY-MM-DD")
            : "",
          ReturnDate: values?.ReturnDate
            ? moment(values?.ReturnDate)?.format("YYYY-MM-DD")
            : "",
          Adult: values?.Adult ? +values?.Adult : 0,
          Child: values?.Child
            ? values?.Child !== "zero"
              ? +values?.Child
              : 0
            : 0,
          Infant: values?.Infant
            ? values?.Infant !== "zero"
              ? +values?.Infant
              : 0
            : 0,
          FlightClassID: values?.FlightClassID ? +values?.FlightClassID : null,
          PreferredAirlineID: values?.PreferredAirlineID
            ? values?.PreferredAirlineID?.join(", ")
            : "",
          InquirySourceID: values?.InquirySourceID
            ? +values?.InquirySourceID
            : null,
          ExpClosureDate: values?.ExpClosureDate
            ? moment(values?.ExpClosureDate)?.format("YYYY-MM-DD")
            : null,
          ExpClosureAmount: values?.ExpClosureAmount
            ? +values?.ExpClosureAmount
            : null,
          Remarks: values?.Remarks ? values?.Remarks : "",
        };
        try {
          const response = await dispatch(updateFlightInquiry(editPayload));
          if (response?.meta?.requestStatus === "fulfilled") {
            dispatch(clearInquiryDetails());
            navigate(-1);
          }
        } catch (error) {
          console.error("Error in handleSubmit:", error);
          throw error;
        }
      } else {
        const insertPayload = {
          ContactID: contactID,
          LeadID: values?.LeadID ? +values?.LeadID : null,
          RequirementType: values?.RequirementType
            ? values?.RequirementType
            : "",
          FirstName: values?.FirstName ? values?.FirstName : "",
          LastName: values?.LastName ? values?.LastName : "",
          MobileNo: values?.MobileNo ? `${values?.MobileNo}` : "",
          EmailID: values?.EmailID ? values?.EmailID : "",
          TripType: values?.TripType ? values?.TripType : "",
          FromPlaceID: values?.FromPlaceID ? +values?.FromPlaceID : null,
          ToPlaceID: values?.ToPlaceID ? +values?.ToPlaceID : null,
          DepartureDate: values?.DepartureDate
            ? moment(values?.DepartureDate)?.format("YYYY-MM-DD")
            : "",
          ReturnDate: values?.ReturnDate
            ? moment(values?.ReturnDate)?.format("YYYY-MM-DD")
            : "",
          Adult: values?.Adult ? +values?.Adult : 0,
          Child: values?.Child
            ? values?.Child !== "zero"
              ? +values?.Child
              : 0
            : 0,
          Infant: values?.Infant
            ? values?.Infant !== "zero"
              ? +values?.Infant
              : 0
            : 0,
          FlightClassID: values?.FlightClassID ? +values?.FlightClassID : null,
          PreferredAirlineID: values?.PreferredAirlineID
            ? values?.PreferredAirlineID?.join(", ")
            : "",
          InquirySourceID: values?.InquirySourceID
            ? +values?.InquirySourceID
            : null,
          ExpClosureDate: values?.ExpClosureDate
            ? moment(values?.ExpClosureDate)?.format("YYYY-MM-DD")
            : null,
          ExpClosureAmount: values?.ExpClosureAmount
            ? +values?.ExpClosureAmount
            : null,
          Remarks: values?.Remarks ? values?.Remarks : "",
        };
        try {
          const response = await dispatch(createFlightInquiry(insertPayload));
          if (response?.meta?.requestStatus === "fulfilled") {
            dispatch(clearInquiryDetails());
            navigate(-1);
          }
        } catch (error) {
          console.error("Error in handleSubmit:", error);
          throw error;
        }
      }
    }
  };

  return (
    <>
      {(loading || leadLoading) && <LoadingPanel gridRef={gridRef} />}
      <Form
        key={formKey}
        onSubmit={handleSubmit}
        initialValues={initialValues}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <ShadowCard style={{ padding: 12, marginBottom: 10 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4 className="typography-head">
                    {InquiryID ? "Update Inquiry" : "Add Inquiry"}
                  </Typography.h4>
                </GridLayoutItem>
                {LeadID || InquiryID ? (
                  <GridLayoutItem style={{ width: "100%" }} colSpan={3}>
                    <table className="w-100">
                      <tr>
                        <th>Name</th>
                        <td>:</td>
                        <td>
                          {initialValues?.FirstName} {initialValues?.LastName}
                        </td>
                      </tr>
                      <tr>
                        <th>Mobile No.</th>
                        <td>:</td>
                        <td>{initialValues?.MobileNo}</td>
                        <th>Email ID</th>
                        <td>:</td>
                        <td>{initialValues?.EmailID}</td>
                      </tr>
                    </table>
                    <hr className="mt-4 mb-4" />
                  </GridLayoutItem>
                ) : (
                  <>
                    <GridLayoutItem className="d-flex gap-2">
                      <Field
                        wrapperStyle={{
                          width: "100%",
                          flex: 1,
                        }}
                        id={"Initial"}
                        name={"Initial"}
                        label={"Initial"}
                        placeholder="i.e. Mr."
                        component={FormSelectionField}
                        options={NAMEPREFIX?.map((initial: any) => {
                          return {
                            value: initial?.value,
                            label: initial?.label,
                          };
                        })}
                      />
                      <Field
                        wrapperStyle={{
                          width: "100%",
                          flex: 2,
                        }}
                        name="FirstName"
                        label="First Name"
                        placeholder="i.e.John"
                        maxLength="100"
                        component={FormTextField}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="LastName"
                        label="Last Name"
                        placeholder="i.e. Smith"
                        maxLength="100"
                        component={FormTextField}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="EmailID"
                        label="Email ID"
                        astrike={true}
                        placeholder="i.e. example@gmail.com"
                        component={FormTextField}
                        validator={emailValidator}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem className="mb-4">
                      <Field
                        wrapperStyle={{
                          width: "100%",
                          flex: 1,
                        }}
                        name="CountryCode"
                        label="Code"
                        astrike={true}
                        placeholder="i.e. In"
                        component={CountryCodeField}
                        validator={requiredValidator}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperStyle={{
                          width: "100%",
                          flex: 2,
                        }}
                        name="MobileNo"
                        label="Mobile No."
                        type="number"
                        max={16}
                        placeholder="i.e. 9999999999"
                        component={FormTextField}
                        astrike={true}
                        validator={MobileNoIntValidator}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="w-100"
                        id={"LeadSourceID"}
                        name={"LeadSourceID"}
                        label={"Lead Source"}
                        placeholder="Lead Source"
                        component={FormSelectionField}
                        astrike={true}
                        validator={requiredValidator}
                        options={LeadSourceList?.map(
                          (leadsource: ILeadSource) => {
                            return {
                              value: leadsource?.ID,
                              label: leadsource?.Source,
                            };
                          }
                        )}
                      />
                    </GridLayoutItem>
                  </>
                )}
                <GridLayoutItem colSpan={3}>
                  <div
                    style={{
                      background: "#edeaea",
                      borderRadius: 10,
                      padding: "1px 10px 15px",
                      fontWeight: 600,
                    }}
                  >
                    <Field
                      // wrapperStyle={{
                      //   marginTop: 8,
                      // }}
                      label={"Requirement Type :"}
                      id={"RequirementType"}
                      name={"RequirementType"}
                      component={FormRadioGroup}
                      layout="horizontal"
                      options={INQUIRYQUERIES}
                      validator={requiredValidator}
                      wrapperClassName="d-flex align-items-center gap-4"
                      // astrike={true}
                    />
                  </div>
                </GridLayoutItem>
                {formRenderProps.valueGetter("RequirementType") ===
                  "PACKAGE" && (
                  <>
                    <GridLayoutItem colSpan={3}>
                      <Field
                        wrapperStyle={{
                          marginTop: 8,
                        }}
                        id={"QueryType"}
                        name={"QueryType"}
                        label={"Query Type"}
                        component={FormRadioGroup}
                        layout="horizontal"
                        options={QUERYTYPES}
                        validator={requiredValidator}
                        // astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="w-100"
                        id={"DestinationID"}
                        name={"DestinationID"}
                        label={"Going To"}
                        placeholder="Going To"
                        component={FormMultiSelectionFiled}
                        astrike={true}
                        validator={requiredValidator}
                        options={CityList?.map((city: ICity) => {
                          return {
                            value: city?.ID,
                            label: city?.CityName,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="w-100"
                        id={"GoingfromID"}
                        name={"GoingfromID"}
                        label={"Going From"}
                        placeholder="Going From"
                        component={FormSelectionField}
                        astrike={true}
                        validator={requiredValidator}
                        options={CityList?.map((city: ICity) => {
                          return {
                            value: city?.ID,
                            label: city?.CityName,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name={"TravelDate"}
                        label="Travel Date"
                        format="dd/MM/yyyy"
                        astrike={true}
                        component={FormDatePicker}
                        validator={requiredValidator}
                        minDate={moment().toDate()}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="right-aligned-field"
                        name="NoOfNights"
                        label="No Of Nights"
                        placeholder="0"
                        max={50}
                        format="n0"
                        component={FormNumericTextField}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="right-aligned-field"
                        name="NoOfPax"
                        label="No Of Pax"
                        placeholder="0"
                        max={50}
                        format="n0"
                        component={FormNumericTextField}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="right-aligned-field"
                        name="Budget"
                        label="Budget"
                        placeholder="0"
                        component={FormNumericTextField}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="w-100"
                        id={"InquirySourceID"}
                        name={"InquirySourceID"}
                        label={"Lead Source"}
                        placeholder="Lead Source"
                        component={FormSelectionField}
                        astrike={true}
                        validator={requiredValidator}
                        options={LeadSourceList?.map(
                          (leadsource: ILeadSource) => {
                            return {
                              value: leadsource?.ID,
                              label: leadsource?.Source,
                            };
                          }
                        )}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem colSpan={2}>
                      <Field
                        id={"HotelPreference"}
                        name={"HotelPreference"}
                        title={"Hotel Preference"}
                        marginRight={20}
                        marginBeetween={5}
                        component={FormCheckboxGroup}
                        options={HOTELPREFERENCE}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        id={"FoodPreferenceID"}
                        name={"FoodPreferenceID"}
                        label={"Food Preference"}
                        placeholder="i.e. Regular"
                        component={FormSelectionField}
                        options={FoodOptionList?.map(
                          (foodoption: IFoodOption) => {
                            return {
                              value: foodoption?.ID,
                              label: foodoption?.Name,
                            };
                          }
                        )}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name={"ExpClosureDate"}
                        label="Expected Closure Date"
                        format="dd/MM/yyyy"
                        astrike={true}
                        component={FormDatePicker}
                        validator={requiredValidator}
                        minDate={moment().toDate()}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="right-aligned-field"
                        name="ExpClosureAmount"
                        label="Expected Closure Amount"
                        placeholder="0"
                        format="n0"
                        component={FormNumericTextField}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem colSpan={2}>
                      <Field
                        name="Remarks"
                        label="Remarks"
                        placeholder="Remarks"
                        component={FormTextField}
                      />
                    </GridLayoutItem>
                  </>
                )}

                {formRenderProps.valueGetter("RequirementType") ===
                  "FLIGHT" && (
                  <>
                    <GridLayoutItem colSpan={3}>
                      <Field
                        wrapperStyle={{
                          marginTop: 8,
                        }}
                        id={"TripType"}
                        name={"TripType"}
                        label={"Trip Type"}
                        component={FormRadioGroup}
                        layout="horizontal"
                        options={TRIPTYPE}
                        validator={requiredValidator}
                        // astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="w-100"
                        id={"FromPlaceID"}
                        name={"FromPlaceID"}
                        label={"Source City"}
                        placeholder="Source City"
                        component={FormSelectionField}
                        astrike={true}
                        validator={requiredValidator}
                        options={CityList?.map((city: ICity) => {
                          return {
                            value: city?.ID,
                            label: city?.CityName,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="w-100"
                        id={"ToPlaceID"}
                        name={"ToPlaceID"}
                        label={"Destination City"}
                        placeholder="Destination City"
                        component={FormSelectionField}
                        astrike={true}
                        validator={requiredValidator}
                        options={CityList?.map((city: ICity) => {
                          return {
                            value: city?.ID,
                            label: city?.CityName,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name={"DepartureDate"}
                        label="Departure Date"
                        format="dd/MM/yyyy"
                        astrike={true}
                        component={FormDatePicker}
                        validator={requiredValidator}
                        minDate={moment().toDate()}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name={"ReturnDate"}
                        label="Return Date"
                        format="dd/MM/yyyy"
                        astrike={true}
                        minDate={moment(
                          formRenderProps.valueGetter("DepartureDate")
                        ).toDate()}
                        component={FormDatePicker}
                        validator={requiredValidator}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        id={"Adult"}
                        name={"Adult"}
                        label={"Adult"}
                        placeholder="Adult"
                        astrike={true}
                        validator={requiredValidator}
                        component={FormSelectionField}
                        options={PAXCOUNT?.map((count: any) => {
                          return {
                            value: count?.value,
                            label: count?.label,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        id={"Child"}
                        name={"Child"}
                        label={"Child"}
                        placeholder="Child"
                        astrike={true}
                        validator={requiredValidator}
                        component={FormSelectionField}
                        options={[
                          {
                            value: "zero",
                            label: "0",
                          },
                          ...(Array.isArray(PAXCOUNT)
                            ? PAXCOUNT.map((count: any) => ({
                                value: count.value,
                                label: count.label,
                              }))
                            : []),
                        ]}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        id={"Infant"}
                        name={"Infant"}
                        label={"Infant"}
                        placeholder="Infant"
                        astrike={true}
                        validator={requiredValidator}
                        component={FormSelectionField}
                        options={[
                          {
                            value: "zero",
                            label: "0",
                          },
                          ...(Array.isArray(PAXCOUNT)
                            ? PAXCOUNT.map((count: any) => ({
                                value: count.value,
                                label: count.label,
                              }))
                            : []),
                        ]}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="w-100"
                        id={"FlightClassID"}
                        name={"FlightClassID"}
                        label={"Flight Class"}
                        placeholder="Flight Class"
                        component={FormSelectionField}
                        astrike={true}
                        validator={requiredValidator}
                        options={AirlineClassList?.map(
                          (flightclass: IAirlineClass) => {
                            return {
                              value: flightclass?.ID,
                              label: flightclass?.ClassName,
                            };
                          }
                        )}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="w-100"
                        id={"PreferredAirlineID"}
                        name={"PreferredAirlineID"}
                        label={"Preferred Airline"}
                        placeholder="Preferred Airline"
                        component={FormMultiSelectionFiled}
                        astrike={true}
                        validator={requiredArrayValidator}
                        options={AirlineList?.map((airline: IAirline) => {
                          return {
                            value: airline?.ID,
                            label: airline?.AirlineName,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="w-100"
                        id={"InquirySourceID"}
                        name={"InquirySourceID"}
                        label={"Lead Source"}
                        placeholder="Lead Source"
                        component={FormSelectionField}
                        astrike={true}
                        validator={requiredValidator}
                        options={LeadSourceList?.map(
                          (leadsource: ILeadSource) => {
                            return {
                              value: leadsource?.ID,
                              label: leadsource?.Source,
                            };
                          }
                        )}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name={"ExpClosureDate"}
                        label="Expected Closure Date"
                        format="dd/MM/yyyy"
                        astrike={true}
                        component={FormDatePicker}
                        validator={requiredValidator}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="right-aligned-field"
                        name="ExpClosureAmount"
                        label="Expected Closure Amount"
                        placeholder="0"
                        format="n0"
                        component={FormNumericTextField}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem colSpan={2}>
                      <Field
                        name="Remarks"
                        label="Remarks"
                        placeholder="Remarks"
                        component={FormTextField}
                      />
                    </GridLayoutItem>
                  </>
                )}
                <GridLayoutItem
                  colSpan={3}
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "end",
                    marginTop: 20,
                  }}
                >
                  <ButtonForAll
                    label={InquiryID ? "Update" : "Save"}
                    type="submit"
                    disabled={!formRenderProps.allowSubmit || loading}
                  />

                  <RippleButton
                    type="button"
                    fillMode="outline"
                    themeColor="primary"
                    style={{ marginLeft: 10 }}
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </RippleButton>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateInquiry;
